import { zMdmFile } from "src/types/ZMdmFile";
import { zSidLabel } from "src/types/ZSidLabel";
import z from "zod";

import { ZAttrType, zAttrType } from "./ZAttrMeta";

const zAttrValueRecord = z.record(z.string(), z.unknown());
export type ZAttrValueRecord = z.infer<typeof zAttrValueRecord>;

export const zAttrValueListRaw = z
  .record(z.string(), zAttrValueRecord)
  .nullable();
export type ZAttrValueListRaw = z.infer<typeof zAttrValueListRaw>;

// Такая конструкция помогает синхронизировать список типов с ZTypeDef. Но в zAttrValue их всё равно надо добавлять вручную
const valMap = {
  string: z.object({
    type: z.literal(zAttrType.enum.string),
    value: z.string().nullable(),
  }),
  number: z.object({
    type: z.literal(zAttrType.enum.number),
    value: z.number().nullable(),
  }),
  boolean: z.object({
    type: z.literal(zAttrType.enum.boolean),
    value: z.boolean().nullable(),
  }),
  strOption: z.object({
    type: z.literal(zAttrType.enum.strOption),
    value: zSidLabel.nullable(),
  }),
  dateTime: z.object({
    type: z.literal(zAttrType.enum.dateTime),
    value: z.string().nullable(),
  }),
  file: z.object({
    type: z.literal(zAttrType.enum.file),
    value: zMdmFile.nullable(),
  }),
  list: z.object({
    type: z.literal(zAttrType.enum.list),
    value: zAttrValueListRaw,
  }),
  array: z.object({
    type: z.literal(zAttrType.enum.array),
    value: z.unknown().array().nullable(),
  }),
} satisfies Record<ZAttrType, z.ZodObject>;

export type ZAttrValueString = z.infer<typeof valMap.string>;
export type ZAttrValueNumber = z.infer<typeof valMap.number>;
export type ZAttrValueList = z.infer<typeof valMap.list>;

export const zAttrValue = z.discriminatedUnion("type", [
  valMap.string,
  valMap.number,
  valMap.boolean,
  valMap.strOption,
  valMap.dateTime,
  valMap.file,
  valMap.list,
  valMap.array,
]);
export type ZAttrValue = z.infer<typeof zAttrValue>;

export const zUnsafeValues = z.record(z.string(), z.unknown());
export type ZUnsafeValues = z.infer<typeof zUnsafeValues>;

export const zUnsafeDataMap = z
  .record(z.string(), zUnsafeValues)
  .describe("scheme.name => unsafe attribute values");
export type ZUnsafeDataMap = z.infer<typeof zUnsafeDataMap>;

export const zSafeValues = z.record(z.string(), zAttrValue);
export type ZSafeValues = z.infer<typeof zSafeValues>;

export const zSafeDataMap = z
  .record(z.string(), zSafeValues)
  .describe("scheme.name => safe attribute values");
export type ZSafeDataMap = z.infer<typeof zSafeDataMap>;
